// extracted by mini-css-extract-plugin
module.exports = {"advertisers-page":"advertisers_advertisers-page__3e5nU","overflow-hidden-container":"advertisers_overflow-hidden-container__3b6zt"};